import * as folders from '@wix/auto_sdk_autocms-folders-service_folders';

export { folders };
